import { connect } from '@/common/lib/riot-redux';
import SearchSelect from './search-select.riot';

/* このファイルは props の参考のため */
const mapStateToProps = (state, props) => {
  /**
   * item の一覧
   * @type {any[]}
   */
  const itemList = props.itemList;
  
  /**
   * 現在の value, getId から取得したものと同じ
   */
  const value = props.value;

  /**
   * チェックボックスの状態をキープするか
   * （true だと、同じアイテムの2回目のクリックは解除扱い、false だと何度クリックしても選択扱い）
   * @type {boolean}
   */
  const unselectable = props.unselectable != null ? true : false;

  /**
   * item が選択された時の callback
   * @type {(itemId: string) => void}
   */
  const onChange = props.onChange;

  /**
   * 一覧で表示する item のラベル。
   * 検索フィルターに含まれているかにも使われる。
   * @type {(item: any) => string}
   */
  const getLabel = props.getLabel;

  /**
   * item の unique id
   * @type {(item: any) => string}
   */
  const getId = props.getId;

  /**
   * item がフィルターに引っかかるか
   * @type {(item: any, filter: string) => boolean}
   */
  const checkMatch = props.checkMatch;

  return {
    itemList,
    value,
    unselectable,
    onChange,
    getLabel,
    getId,
    checkMatch,
  };
};

export default connect(SearchSelect, mapStateToProps);